import { render, staticRenderFns } from "./CounselingEventChat.vue?vue&type=template&id=b651821e&scoped=true&"
import script from "./CounselingEventChat.vue?vue&type=script&lang=js&"
export * from "./CounselingEventChat.vue?vue&type=script&lang=js&"
import style0 from "./CounselingEventChat.vue?vue&type=style&index=0&id=b651821e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b651821e",
  null
  
)

export default component.exports